// extracted by mini-css-extract-plugin
export default {"loader":"GUdzNb","loaderSvg":"vRabuo","imageLoading":"sFreOt","imageStyling":"vkpl7f"};